import React from 'react'

import { SubTitle, RowWrap, QuestionTitle } from './styled'
import { AnswerEmotion } from './AnswerEmotion'

import { ActionAnswer } from 'src/api/quizzes/types'

export interface DisagreedQuestion {
  userAnswer: ActionAnswer
  otherUserAnswer: ActionAnswer
  title: string
}

interface Props {
  disagreedQuestions: DisagreedQuestion[]
  subtitle?: string
}

export const DisagreeAnswersList: React.FC<Props> = ({
  disagreedQuestions,
  subtitle,
}) =>
  disagreedQuestions.length > 0 ? (
    <>
      {subtitle && <SubTitle>You Disagree...</SubTitle>}
      {disagreedQuestions.map(({ title, userAnswer, otherUserAnswer }) => (
        <RowWrap key={title}>
          <AnswerEmotion answer={otherUserAnswer} />
          <QuestionTitle>{title}</QuestionTitle>
          <AnswerEmotion answer={userAnswer} />
        </RowWrap>
      ))}
    </>
  ) : null
